import moment from 'moment';

export default class ManageStudentDialogController {
  constructor(
    $log, $scope, $mdDialog, successCallback, errorCallback, StudentService, $mdToast, student
  ) {
    'ngInject';
    this.$log = $log;
    this.$scope = $scope;
    this.$mdDialog = $mdDialog;
    this.StudentService = StudentService;
    this.$mdToast = $mdToast;
    this.student = {...student};
    this.formData = angular.copy(student);
    this.successCallback = value => successCallback(value);
    this.errorCallback = error => {
      this.$mdDialog.cancel();
      if (angular.isFunction(errorCallback)) {
        errorCallback(error);
      }
    };
  }

  closeDialog() {
    this.$mdDialog.hide();
  }

  validateDays() {
    let isValid = true;
    if (this.formData.isPermittedToLeaveOnOwn) {
      Object.entries(this.formData.permissionsSchedule).forEach(([_dayKey, entry]) => {
        if (!entry.hour && entry.type === 'specific_hour') {
          entry.error = true;
          isValid = false;
        } else {
          entry.error = false;
        }
      });
    }

    return isValid;
  }

  submitStudentData() {
    const payload = angular.copy(this.formData);
    Object.entries(payload.permissionsSchedule).forEach(([_dayKey, entry]) => {
      if (entry.hour) {
        const m = moment(entry.hour);
        entry.hour = m.isValid() ? m.format('HH:mm') : null;
      }
    });
    if (payload.isPermittedToLeaveOnOwn === false) {
      payload.permissionsSchedule = this.student.permissionsSchedule;
    }

    if (this.validateDays()) {
      this.StudentService.edit(payload)
        .then(() => {
          this.successCallback({result: payload});
          this.$mdDialog.hide();
          this.$mdToast.show(
            this.$mdToast.simple()
              .textContent('Zapisano zmiany')
              .position('bottom right')
              .hideDelay(3000)
          );
        })
        .catch(error => {
          this.errorCallback(error);
          this.$mdToast.show(
            this.$mdToast.simple()
              .textContent('Nie udało się zapisać zmian')
              .position('bottom right')
              .hideDelay(3000)
          );
        });
    } else {
      this.$mdToast.show(
        this.$mdToast.simple()
          .textContent('Nie udało się zapisać zmian')
          .position('bottom right')
          .hideDelay(3000)
      );
    }
  }
}
